export const showModalCustomEvent = (modalName: string, params: any = {}) => ({
  event: 'custom-event',
  category: 'modals',
  action: `show-${modalName}-modal`,
  label: '',
  ...params,
});
